import { Box, Button, Stack } from '@mui/material';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import {
  AttachmentText,
  PrimaryButton,
} from '../../../../components/style/ButtonStyle';
import {
  FacilityDivider,
  FacilityTabPanel,
  InfoText,
} from '../../../../components/style/TabStyle';
import { IconLabel } from '../../../../components/style/TextStyle';
import {
  AddressIcon,
  BuildingIcon,
  EditIcon,
  FolderIcon,
  InfomationIcon,
  MapIcon,
} from '../../../../layouts/dashboard/nav/IconButton';
import { fDate } from '../../../../utils/formatTime';
import { DeleteFacilityButton } from './DeleteFacilityButton';
import { sliceSerialNumber } from '../../../../utils/helper';
// ----------------------------------------------------------------------

export default function RegularTypeInfoPanel({
  value,
  facility,
  getResult,
}: any) {
  const navigate = useNavigate();

  return (
    <FacilityTabPanel value={value}>
      <Stack spacing={2.5}>
        <Stack direction="row" spacing={1} alignItems="center">
          <AddressIcon />
          <IconLabel>주소</IconLabel>
          <Box />
          <InfoText>{facility?.addressName || '-'}</InfoText>
        </Stack>
        <FacilityDivider />
        <Stack direction="row" spacing={1} alignItems="center">
          <MapIcon />
          <IconLabel>위치참고</IconLabel>
          <Box />
          <InfoText>{facility?.addressNote || '-'}</InfoText>
        </Stack>
        <FacilityDivider />

        <Stack direction="row" spacing={1} alignItems="center">
          <BuildingIcon />
          <IconLabel>시설명</IconLabel>
          <Box />
          <InfoText>{facility?.title || '-'}</InfoText>
        </Stack>
        <FacilityDivider />

        <Stack direction="row" spacing={1} alignItems="center">
          <InfomationIcon />
          <IconLabel>자세한 정보</IconLabel>
          <Box />
        </Stack>
        <Stack spacing={0.5}>
          <InfoText>구분 : {facility?.category || '-'}</InfoText>
          <InfoText>
            설치일 : {fDate(facility?.dateOfInstall, 'yyyy-MM-dd') || '-'}
          </InfoText>
          <InfoText>
            관리부서 : {facility?.maintenanceDepartment || '-'}
          </InfoText>
          <InfoText>연락처 : {facility?.contactNumber || '-'}</InfoText>
          <InfoText>
            관리번호 : {sliceSerialNumber(facility?.serialNumber) || '-'}
          </InfoText>
          <InfoText sx={{ maxWidth: 320 }}>
            비고 : {facility?.notes === null ? '-' : facility?.notes || '-'}
          </InfoText>
        </Stack>
        <FacilityDivider />
        <Stack direction="row" spacing={1} alignItems="center">
          <FolderIcon />
          <IconLabel>첨부파일</IconLabel>
          <Box />
          <Stack direction="column" spacing={0.5}>
            {_.map(facility?.attachmentDetails, (attachment, index) => {
              return (
                <a
                  key={index}
                  href={attachment?.url}
                  target="_blank"
                  rel="noreferrer"
                  download={attachment?.name}
                >
                  <Button variant="text">
                    <AttachmentText>{attachment?.name}</AttachmentText>
                  </Button>
                </a>
              );
            })}
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1} mt={5}>
        <PrimaryButton
          startIcon={<EditIcon />}
          onClick={() => {
            navigate(
              `/facility/${facility?.facilityId}/form?lat=${facility?.latitude}&lng=${facility?.longitude}&zoom=15&roadAddress=${facility?.addressName}&jibunAddress=${facility?.addressName}`,
            );
          }}
        >
          수정하기
        </PrimaryButton>
        <DeleteFacilityButton
          facilityId={facility?.facilityId}
          getResult={getResult}
        />
      </Stack>
    </FacilityTabPanel>
  );
}
